import { fetchMemberNameMap, type MemberNameMapResponse } from "@/api/member";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";

export function useMemberNameMap() {
  const { data = [], isLoading, isError } = useQuery<MemberNameMapResponse[]>({
    queryKey: ["member-name-map"],
    queryFn: fetchMemberNameMap,
  });

  const nameMap = useMemo(
    () => new Map(data.map((m) => [m.id, m])),
    [data],
  );

  const getName = useCallback(
    (id: number): string => nameMap.get(id)?.name ?? "Unknown",
    [nameMap],
  );

  return { nameMap, getName, isLoading, isError };
}
